<script lang="ts">
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Flash from "@shared/services/flashv2";
  import type { QuickOrderListDetail } from "@shared/types/QuickOrderList";

  export let showDeleteModal;
  export let list: QuickOrderListDetail;

  const closeModal = () => {
    showDeleteModal = false;
  };

  const deleteList = async () => {
    HttpPromise({
      method: "DELETE",
      url: `/api/retailer/quick_order_lists/${list.id}`,
    }).then(
      function success(res) {
        closeModal();
        // @ts-ignore
        window.stateService.go("layout.quick_order_list_index");
        Flash.now({ type: "success", message: "Success! List deleted from account" });
      },
      function error(res) {
        Flash.now({
          type: "error",
          message: "There was an error deleting the list. Please try again.",
        });
      }
    );
  };

</script>

<Modal bind:show={showDeleteModal} fizzModal={true} size="small" closeOnBackgroundClick={false}>
  <div class="layout-header-footer">
    <header class="fizz-modal-header fizz-space-between">
      <h4 class="fizz-heading-3">Delete list?</h4>
      <div class="fizz-modal-toggle fizz-modal-close" on:click|preventDefault={closeModal}>
        <Icon type="X" extraClassNames="fizz-text-brand cursor-pointer" height="16" width="16" />
      </div>
    </header>

    <section class="fizz-modal-main fizz-flow-16 padding-bottom--medium">
      <p>Are you sure you want to delete this list?</p>
    </section>

    <section class="fizz-modal-footer fizz-flex-row fizz-justify-end">
      <button class="fizz-button" on:click|preventDefault={closeModal}>Cancel</button>
      <button class="fizz-button-secondary" on:click|preventDefault={deleteList}>Delete</button>
    </section>
  </div>
</Modal>
